(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-new_202609"] && !Shopify.designMode) return;
  try {
    
/* ---- banner slider：1枚表示のため一時停止中（再開時は下の // を外す） ---- */
// (function(){
//   /* ---- banner slider（無限ループ：前後に複製スライドを配置） ---- */
//   var track=document.querySelector('[data-track]');
//   var dotsWrap=document.querySelector('[data-dots]');
//   if(!track) return;
//   var originals=Array.prototype.slice.call(track.children);
//   var n=originals.length, pos=n, timer=null;
//   if(!n) return;
//
//   // 本物のスライド一式を前後に複製（端でも両隣が見えるように）
//   function makeClone(s){
//     var c=s.cloneNode(true);
//     c.setAttribute('aria-hidden','true');
//     c.setAttribute('tabindex','-1');
//     c.classList.add('renewal-top2609-banner__slide--clone');
//     return c;
//   }
//   originals.forEach(function(s){ track.appendChild(makeClone(s)); });
//   for(var r=n-1;r>=0;r--){ track.insertBefore(makeClone(originals[r]),track.firstChild); }
//   var slides=track.children; // [複製 n枚][本物 n枚][複製 n枚]
//   track.classList.add('renewal-top2609-banner__track--carousel');
//
//   for(var i=0;i<n;i++){
//     var b=document.createElement('button');
//     b.type='button';b.setAttribute('aria-label',(i+1)+'枚目へ');
//     b.addEventListener('click',(function(k){return function(){normalize();setPos(n+k,true);restart();};})(i));
//     dotsWrap.appendChild(b);
//   }
//
//   function setPos(p,animate){
//     pos=p;
//     var w=slides[0].getBoundingClientRect().width;
//     var gap=parseFloat(getComputedStyle(track).columnGap)||0;
//     if(!animate){ track.style.transition='none'; }
//     track.style.transform='translateX('+(-(pos*(w+gap))-w/2)+'px)';
//     if(!animate){ void track.offsetWidth; track.style.transition=''; }
//     var idx=((pos-n)%n+n)%n;
//     Array.prototype.forEach.call(dotsWrap.children,function(d,j){d.classList.toggle('renewal-top2609-is-active',j===idx);});
//   }
//   // 複製側にいる場合は、見た目を変えずに本物側の同じスライドへ移動
//   function normalize(){
//     if(pos>=2*n){ setPos(pos-n,false); }
//     else if(pos<n){ setPos(pos+n,false); }
//   }
//   function move(d){ normalize(); setPos(pos+d,true); }
//   track.addEventListener('transitionend',function(e){ if(e.target===track){ normalize(); } });
//
//   function restart(){clearInterval(timer);timer=setInterval(function(){move(1);},5000);}
//   // swipe
//   var sx=null;
//   track.addEventListener('touchstart',function(e){sx=e.touches[0].clientX;},{passive:true});
//   track.addEventListener('touchend',function(e){
//     if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;
//     if(Math.abs(dx)>40){move(dx<0?1:-1);restart();}sx=null;
//   });
//   window.addEventListener('resize',function(){setPos(pos,false);});
//   setPos(n,false); restart();
// })();


/* ---- 追記：SP 28日間スライドのスクロール案内 ---- */
(function(){
  var wrap=document.querySelector('[data-phase]');
  if(!wrap) return;
  var strip=wrap.querySelector('.renewal-top2609-phase');
  strip.addEventListener('scroll',function(){
    if(strip.scrollLeft>10){ wrap.classList.add('renewal-top2609-is-scrolled'); }
  },{passive:true});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to"]) return;
  try {
    
    /* =========================================================
       商品別・使い方解説：タブ切り替え
       - .product-howto-tab[data-tab-target] を押すと、同じ id の .product-howto-panel を表示
       - ← → / Home / End キーでもタブを移動できる
       - URL に #product-howto-serum などが付いていれば、そのタブを開いた状態で表示
       ========================================================= */
    (function () {
      'use strict';

      function initTabs() {
        document.querySelectorAll('.product-howto-tabs[role="tablist"]').forEach(function (tablist) {
          var tabs = Array.prototype.slice.call(tablist.querySelectorAll('.product-howto-tab[data-tab-target]'));
          if (!tabs.length) return;

          function getPanel(tab) {
            return document.getElementById(tab.getAttribute('data-tab-target'));
          }

          function activate(target, options) {
            options = options || {};
            tabs.forEach(function (tab) {
              var isActive = tab === target;
              var panel = getPanel(tab);
              tab.classList.toggle('product-howto-is-active', isActive);
              tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
              tab.setAttribute('tabindex', isActive ? '0' : '-1');
              if (panel) {
                panel.classList.toggle('product-howto-is-active', isActive);
                panel.hidden = !isActive;
              }
            });
            if (options.focus) target.focus();
            if (options.updateHash && history.replaceState) {
              history.replaceState(null, '', '#' + target.getAttribute('data-tab-target'));
            }
          }

          // クリック・タップ
          tabs.forEach(function (tab) {
            tab.addEventListener('click', function (e) {
              e.preventDefault();
              activate(tab, { updateHash: true });
            });
          });

          // キーボード操作
          tablist.addEventListener('keydown', function (e) {
            var current = tabs.indexOf(document.activeElement);
            if (current === -1) return;
            var next = null;
            if (e.key === 'ArrowRight') next = (current + 1) % tabs.length;
            if (e.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
            if (e.key === 'Home') next = 0;
            if (e.key === 'End') next = tabs.length - 1;
            if (next === null) return;
            e.preventDefault();
            activate(tabs[next], { focus: true, updateHash: true });
          });

          // URL のハッシュから初期タブを決める
          function openFromHash() {
            var id = location.hash.replace('#', '');
            if (!id) return;
            var tab = tabs.filter(function (t) {
              return t.getAttribute('data-tab-target') === id;
            })[0];
            if (tab) activate(tab);
          }
          openFromHash();
          window.addEventListener('hashchange', openFromHash);
        });
      }

      // どこに貼っても動くよう、HTMLの読み込み完了を待ってから実行
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initTabs);
      } else {
        initTabs();
      }
    })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["start"]) return;
  try {
    
/* =========================================================
   FAQ アコーディオン
   ・<details class="qa"> の開閉を高さアニメーションで滑らかにする
   ・開閉中にもう一度クリックしても、その位置から逆向きに動く
   ・「視差効果を減らす」設定の端末ではアニメーションなしで開閉
   ========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  const DURATION = 400;                         // ms
  const EASING   = 'cubic-bezier(.4, 0, .2, 1)';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('.start-redeal-qa').forEach((qa) => {
    const summary = qa.querySelector('summary');
    const answer  = qa.querySelector('.start-redeal-qa__a');
    let heightAnim = null;
    let fadeAnim   = null;

    // 最初から open のものはアイコンを − にしておく
    if (qa.open) qa.classList.add('start-redeal-is-open');

    summary.addEventListener('click', (e) => {
      e.preventDefault();                       // ブラウザ標準の即時開閉を止める

      const opening = !qa.classList.contains('start-redeal-is-open');
      const startHeight = qa.offsetHeight;      // 今の高さ（動いている途中でもOK）

      // 動作中のアニメーションがあれば止める
      if (heightAnim) heightAnim.cancel();
      if (fadeAnim) fadeAnim.cancel();

      qa.classList.toggle('start-redeal-is-open', opening);  // アイコン切り替え（CSS側でフェード）

      if (reduceMotion.matches) {
        qa.open = opening;
        return;
      }

      if (opening) qa.open = true;              // 中身を描画して最終の高さを測る
      const endHeight = opening ? qa.offsetHeight : summary.offsetHeight;

      heightAnim = qa.animate(
        { height: [`${startHeight}px`, `${endHeight}px`] },
        { duration: DURATION, easing: EASING }
      );
      fadeAnim = answer.animate(
        { opacity: opening ? [0, 1] : [1, 0] },
        { duration: DURATION, easing: EASING, fill: 'forwards' }
      );

      heightAnim.onfinish = () => {
        if (!opening) qa.open = false;          // 閉じ終わってから details を閉じる
        heightAnim.cancel();
        fadeAnim.cancel();
        heightAnim = fadeAnim = null;
      };
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
